import{_ as r}from"./_castPath.js";import{_ as o}from"./_toKey.js";var t=r,a=o;var s=function(r,o){for(var s=0,n=(o=t(o,r)).length;null!=r&&s<n;)r=r[a(o[s++])];return s&&s==n?r:void 0};export{s as _};
